export const DEFAULT_LOCALE = 'en';

/**
 * Build an internal href that matches the public URL strategy enforced by
 * proxy.ts and the XML sitemap: the default locale (English) is served at
 * clean, unprefixed paths, while other locales are prefixed (e.g. /es/...).
 *
 * Using this instead of hardcoding `/${lang}/...` avoids emitting /en/... URLs
 * that only exist to 301-redirect to their clean form — those duplicate URLs
 * get crawled and excluded by Google as "alternate page with proper canonical".
 *
 * @param lang  current locale (e.g. 'en', 'es')
 * @param path  path after the locale segment, e.g. '/blog', '/#contact', '#contact'
 */
export function localizedHref(lang: string, path: string = '/'): string {
  const prefix = lang && lang !== DEFAULT_LOCALE ? `/${lang}` : '';

  // Hash-only target → the locale home anchor ('#contact' -> '/#contact' or '/es/#contact')
  if (path.startsWith('#')) {
    return `${prefix}/${path}`;
  }

  // Normalize to a single leading slash; treat '' and '/' as the locale home.
  const clean = path === '' || path === '/' ? '' : path.startsWith('/') ? path : `/${path}`;

  return `${prefix}${clean}` || '/';
}
